exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".createCont[data-v-1208db07]{background:red;min-height:500px;display:flex;font-family:Roboto,sans-serif}.createCont div[data-v-1208db07]{width:50%}.left[data-v-1208db07]{background:#fff;padding:10px;font-family:Roboto,sans-serif;font-size:15px}.right[data-v-1208db07]{background:#fafad2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1208db07","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/codeModules/create.vue
// module id = 433
// module chunks = 0